"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMessageDatesAndContents = exports.generateMessageContent = exports.dynamicFields = exports.unitMillisecond = void 0;
const moment_1 = __importDefault(require("moment"));
// Convert unit index to unit millisecond
const unitMillisecond = (unitIndex) => {
    switch (unitIndex) {
        case 0:
            return 60 * 1000; // minute
        case 1:
            return 3600 * 1000; // hour
        case 2:
            return 86400 * 1000; // day
        case 3:
            return 604800 * 1000; // day
        default:
            return 0;
    }
};
exports.unitMillisecond = unitMillisecond;
// Gets the dynamic fields of template use in message form
const dynamicFields = (appointmentData) => [
    {
        id: "customer-name-4086-8762-6b22ec09b06d",
        name: "CustomerName",
        iconName: "account-outline",
        value: appointmentData?.customer?.name,
    },
    {
        id: "date2a4c-2853-487a-b4ae-0cd98caf588f",
        name: "Date",
        iconName: "calendar-today",
        value: appointmentData?.startDateTime ? (0, moment_1.default)(appointmentData.startDateTime).format("L") : null,
    },
    {
        id: "starttim-e9d8-4c12-9cf1-84a7796b67cb",
        name: "StartTime",
        iconName: "clock-start",
        value: appointmentData?.startDateTime ? (0, moment_1.default)(appointmentData.startDateTime).format("HH:mm") : null,
    },
    {
        id: "endtime4-2468-4e59-8eed-c2087d69ea9b",
        name: "EndTime",
        iconName: "clock-end",
        value: appointmentData?.endDateTime ? (0, moment_1.default)(appointmentData.endDateTime).format("HH:mm") : null,
    },
    {
        id: "service6-e283-4dca-b66c-bb79304e9f62",
        name: "Service",
        iconName: "tag-multiple-outline",
        value: appointmentData?.service?.name,
    },
    { id: "price732-4618-4db9-84b7-8fe10d9d01e0", name: "Price", iconName: "cash", value: appointmentData?.price },
    { id: "notes5ae-5213-45b4-8ef2-583108db920d", name: "Notes", iconName: "note-text-outline", value: appointmentData?.note },
];
exports.dynamicFields = dynamicFields;
// Generate message content for the appointment with the appointment value depending on the template
const generateMessageContent = (template, appointmentData) => {
    if (template) {
        (0, exports.dynamicFields)(appointmentData).forEach(field => {
            template = template?.replace(new RegExp(`{${field.id}}`, "g"), field.value);
        });
    }
    return template;
};
exports.generateMessageContent = generateMessageContent;
const getMessageDatesAndContents = (uid, startDateTime, endDateTime, customer, service, message, price, note) => {
    const appointmentData = {
        startDateTime: startDateTime,
        endDateTime: endDateTime,
        customerIds: [customer.id],
        services: service?.id ? [{ id: service.id, quantity: 1 }] : undefined,
        messageIds: message?.id ? [message.id] : undefined,
        price: price,
        note: note,
    };
    let messageDates;
    let messageContents;
    if (message?.id) {
        // Message contents
        messageContents = [(0, exports.generateMessageContent)(message.template, { ...appointmentData, customer: customer, service: service })];
        // Message dates
        if (message?.sendingTimes?.length === 1) {
            if (message.sendingTimes[0].whenIndex === 0) {
                // Send INSTANT message
                fetch("https://europe-west1-previsy-1f5c2.cloudfunctions.net/SendInstantMessage", {
                    method: "POST",
                    body: JSON.stringify({
                        userId: uid,
                        countryCode: customer.countryCode,
                        toPhoneNumber: customer.phoneNumber,
                        messageBody: messageContents[0],
                    }),
                    headers: { "Content-Type": "application/json" },
                });
            }
            else {
                messageDates = new Array(1);
                if (message.sendingTimes[0].whenIndex === 1) {
                    // Send message BEFORE start date time of the appointment
                    messageDates[0] = new Date(new Date(startDateTime).getTime() - message.sendingTimes[0].number * (0, exports.unitMillisecond)(message.sendingTimes[0].unitIndex));
                }
                else if (message.sendingTimes[0].whenIndex === 2) {
                    // Send message AFTER end date time of the appointment
                    messageDates[0] = new Date(new Date(endDateTime).getTime() + message.sendingTimes[0].number * (0, exports.unitMillisecond)(message.sendingTimes[0].unitIndex));
                }
            }
        }
    }
    return { messageDates, messageContents };
};
exports.getMessageDatesAndContents = getMessageDatesAndContents;
